import { connect } from 'react-redux';
import Layout from './Layout';
import { openSupportWindow } from '../../store/actions/support';

const mapStateToProps = ({
  settingsLoadingReducer,
  userReducer
}) => ({
  settingsLoadingReducer,
  userReducer
});
const mapDispatchToProps = {
  openSupportWindow
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout);
